import * as httpUtil from "@/utils/httpUtil";

const interfaces: Array<Record<string, any>> = [
  {
    method: "post",
    name: "answerWorkTicket",
    url: "/c/pc/freq/ask/question/answerWorkTicket",
    desc: "回复留言工单",
  },
  {
    method: "post",
    name: "countCommunityWorkTick",
    url: "/c/pc/freq/ask/question/countCommunityWorkTick",
    desc: "统计社区的未处理工单信息",
  },
  {
    method: "postExFile",
    name: "exportWorkTickets",
    url: "/c/pc/freq/ask/question/exportWorkTickets",
    desc: "导出工单列表",
  },
  {
    method: "post",
    name: "findAllProcessStateList",
    url: "/c/pc/freq/ask/question/findAllProcessStateList",
    desc: "工单流程状态列表",
  },
  {
    method: "post",
    name: "findWorkTicketTransferLogs",
    url: "/c/pc/freq/ask/question/findWorkTicketTransferLogs",
    desc: "工单流转记录",
  },
  {
    method: "post",
    name: "findAllQuestionType",
    url: "/c/pc/freq/ask/question/findAllQuestionType",
    desc: "工单问题类型列表",
  },
  {
    method: "post",
    name: "findByWorkTicketDetailById",
    url: "/c/pc/freq/ask/question/findByWorkTicketDetailById",
    desc: "留言工单详情",
    //config: { ignoreError: true },
  },
  {
    method: "post",
    name: "findWorkTicketProcessPage",
    url: "/c/pc/freq/ask/question/findWorkTicketProcessPage",
    desc: "分页查询留言工单处理流程列表",
  },
  {
    method: "post",
    name: "markWorkTicketProcessToEnded",
    url: "/c/pc/freq/ask/question/markWorkTicketProcessToEnded",
    desc: "标记完结",
  },
  {
    method: "post",
    name: "recieveWorkTicket",
    url: "/c/pc/freq/ask/question/recieveWorkTicket",
    desc: "接收留言工单",
  },
  {
    method: "post",
    name: "transferWorkTicketToPlatform",
    url: "/c/pc/freq/ask/question/transferWorkTicketToPlatform",
    desc: "工单转平台",
  },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}

export default exportsRender(interfaces);
